import React, { useContext, useEffect, useRef } from 'react'
import dashboardStyle from '../../Styles/ComponentStyles/MainPages/dashboard.module.scss'

import Grid from '@mui/material/Grid2';
import Marquee from "react-fast-marquee";
import { IconButton, Typography } from '@mui/material';

import setting from '../../Assets/Dashboard/setting-gear.svg'

import { DashboardContext, DashboardDetailPayload } from '../../Context/DashboardDetailContext';
import GlobalDialog from '../../Utils/Layout/GlobalDialog/GlobalDialog';
import CustomizeTickerDialog from '../../Pages/Dashboard/DashboardHome/DashboardHomeDialog/CustomizeTickerDialog';

const StocksMarquee = () => {

    const {
        tickerCustomizeDialog,
        setTickerCustomizeDialog,
        tickerSaveDetailsDsh
    } = useContext(DashboardContext) as DashboardDetailPayload

    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const scriptId = "tradingview-ticker-tape-script";
        const existingScript = document.getElementById(scriptId);
        if (existingScript) existingScript.remove();

        const { stokesDetails, customizationOptions } = tickerSaveDetailsDsh;

        const script = document.createElement("script");
        script.id = scriptId;
        script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
        script.async = true;

        const symbols = Array.isArray(stokesDetails)
            ? stokesDetails.map((stock: any) => ({
                proName: `NASDAQ:${stock.stockSymbol}`, // Adjust this if not all are NASDAQ
                title: stock.stockTitle,
            }))
            : [];

        const widgetConfig = {
            symbols,
            showSymbolLogo: customizationOptions?.isLogoVisible ?? true,
            isTransparent: true,
            displayMode: customizationOptions?.displayMode?.toLowerCase() ?? "regular",
            colorTheme: customizationOptions?.colorTheme?.toLowerCase() ?? "dark",
            locale: "en",
        };

        script.innerHTML = JSON.stringify(widgetConfig);

        if (containerRef.current) {
            containerRef.current.innerHTML = ""; // Clear previous content
            containerRef.current.appendChild(script);
        }
    }, [
        tickerSaveDetailsDsh.stockIds,
        tickerSaveDetailsDsh.stokesDetails,
        tickerSaveDetailsDsh.customizationOptions.displayMode,
        tickerSaveDetailsDsh.customizationOptions.colorTheme,
        tickerSaveDetailsDsh.customizationOptions.isLogoVisible
    ]);


    // useEffect(() => {
    //     const scriptId = "tradingview-ticker-tape-script";
    //     const existingScript = document.getElementById(scriptId);

    //     if (existingScript) {
    //         existingScript.remove();
    //     }

    //     const script = document.createElement("script");
    //     script.id = scriptId;
    //     script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
    //     script.async = true;

    //     script.innerHTML = JSON.stringify({
    //         symbols: [
    //             { proName: "FOREXCOM:SPXUSD", title: "S&P 500 Index" },
    //             { proName: "FOREXCOM:NSXUSD", title: "US 100 Cash CFD" },
    //             { proName: "FX_IDC:EURUSD", title: "EUR to USD" },
    //             { proName: "BITSTAMP:BTCUSD", title: "Bitcoin" },
    //             { proName: "BITSTAMP:ETHUSD", title: "Ethereum" }
    //         ],
    //         showSymbolLogo: true,
    //         isTransparent: true, // Background color is solid
    //         displayMode: "regular", // Regular ticker mode
    //         colorTheme: "dark", // Dark theme
    //         locale: "en" // English language
    //     });

    //     if (containerRef.current) {
    //         containerRef.current.innerHTML = ""; // Clear previous content
    //         containerRef.current.appendChild(script);
    //     }
    // }, []);



    return (
        <>
            {tickerCustomizeDialog &&
                <GlobalDialog
                    flagHeadSection={true}
                    maxWidth="md"
                    dialogHead="Customise ticker"
                    open={tickerCustomizeDialog}
                    view={
                        <CustomizeTickerDialog
                            setTickerCustomizeDialog={setTickerCustomizeDialog}
                        />
                    }
                    onClose={() => { setTickerCustomizeDialog(false) }}
                />
            }

            <Grid container>
                <Grid size={{ xs: 12 }} sx={{ position: 'relative' }}>
                    <Grid container>
                        <div
                            className="tradingview-widget-container"
                            ref={containerRef}
                            style={{
                                width: "100%",
                                backgroundColor: tickerSaveDetailsDsh?.customizationOptions?.bgColor
                            }}
                        >
                            <div className="tradingview-widget-container__widget"></div>
                        </div>
                    </Grid>
                    <Grid>
                        <IconButton
                            size='small'
                            className={dashboardStyle.gearImageIcon}
                            onClick={() => { setTickerCustomizeDialog(true) }}
                        >
                            <img src={setting} className={dashboardStyle.gearImage} alt="" />
                        </IconButton>
                    </Grid>

                    {/* <Marquee style={{ background: "black", padding: "5px 0px" }}>
                        {stockMarqueDetails.map((ele: any) => {
                            return (
                                <>
                                    <Grid container sx={{ alignItems: "center", gap: "2px", margin: "0px 10px" }}>
                                        <Grid sx={{ display: 'flex', margin: "0px 5px" }}>
                                            <img src={ele.img} style={{ width: '18px', height: 'auto' }} alt="" />
                                        </Grid>
                                        <Grid>
                                            <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV14}`}>
                                                {ele.stockText}
                                            </Typography>
                                        </Grid>
                                        <Grid sx={{ display: 'flex' }}>
                                            {ele.stockArrow}
                                        </Grid>
                                        <Grid sx={{ display: 'flex' }}>
                                            <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV14}`}>
                                                {ele.stockPrice}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </>
                            )
                        })}
                    </Marquee> */}
                </Grid>
            </Grid>
        </>
    )
}

export default StocksMarquee